import React, { useState } from 'react';
import { ICreateSpotlightFormikValues } from './types';
import { useQueryBackgrounds } from 'lib/api/backgrounds/useQueryBackgrounds';
import { AddBackgroundModal } from '../../aiAssistants/backgrounds/modals/AddBackgroundModal';
import { useCreateSpotlightMutation } from 'lib/api/spotlight/useCreateSpotlightMutation';
import { errorToast } from 'lib/components/toasts/error';
import { AISpotlightForm } from './forms/AISpotlightForm';
import { useHistory } from 'react-router';
import { mapFolderToOption } from 'lib/utils/folders';
import { DEFAULT_FOLDER } from 'lib/const/Folders';
import { useAuth } from 'lib/context';
interface ICreateSpotlightModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CreateAISpotlightModal = ({
  isOpen,
  onClose,
}: ICreateSpotlightModalProps) => {
  const history = useHistory();
  const { userData } = useAuth();
  const [showBackgroundUploadModal, setShowBackgroundUploadModal] =
    useState(false);

  const toggleShowBackgroundUploadModal = () => {
    setShowBackgroundUploadModal(prev => !prev);
  };

  // Fetch backgrounds
  const {
    data: backgrounds,
    isLoading: isLoadingBackgrounds,
    isFetching: isFetchingBackgrounds,
  } = useQueryBackgrounds();
  const defaultBackgroundId =
    backgrounds?.find(bg => !!bg.default)?.backgroundId || 0;

  // Create AI Spotlight modal
  const onCreateSpotlightSuccess = (uploadedVideoId: number) => {
    const targetFolder = mapFolderToOption(DEFAULT_FOLDER, userData.id);
    history.push({
      pathname: '/review-videos',
      state: {
        videos: [uploadedVideoId],
        targetFolder,
        title: 'Add AI Spotlight',
        showCounter: false,
        saveText: 'Save Spotlight',
      },
    });
    onClose();
  };

  // Create Spotlight Mutation
  const { mutateAsync: createSpotlightMutation } = useCreateSpotlightMutation(
    onCreateSpotlightSuccess
  );

  const onSave = async (values: ICreateSpotlightFormikValues) => {
    if (values.backgroundId === 0) {
      errorToast({ title: 'Please select a background before proceeding.' });
      return;
    }
    const submitValues = {
      script: values.text,
      backgroundId: values.backgroundId?.toString(),
    };
    await createSpotlightMutation(submitValues);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <AISpotlightForm
        onSave={onSave}
        onClose={onClose}
        backgrounds={backgrounds || []}
        defaultBackgroundId={defaultBackgroundId}
        isLoading={isLoadingBackgrounds}
        toggleShowBackgroundUploadModal={toggleShowBackgroundUploadModal}
        isFetchingBackgrounds={isFetchingBackgrounds}
      />
      <AddBackgroundModal
        isOpen={showBackgroundUploadModal}
        onClose={toggleShowBackgroundUploadModal}
      />
    </>
  );
};
